export * from './lib/pages/list/list.component';
export * from './lib/pages/auftrag/auftrag.component';
export * from './lib/pages/erstellen/erstellen.component';

export * from './lib/auftrag.permissions'
export * from './lib/auftrag.api'
export * from './lib/auftrag.providers'
export * from './lib/auftrag.routes'

